import Config from '../../config';
import { handleErrors, parseAsJson } from '../../utils/requestHelpers';

export const fetchReportParams = async (periodName: string) => await fetch(
  Config.endpoints.FETCH_CUSTOM_REPORT_PARAMS
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Company code options failed' }))
  .then(parseAsJson);
